import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import Creatable from "react-select/creatable";
const AddRawMaterialModal = ({
  //   handleChange,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const formRef = useRef(null);

  const [Material, setMaterial] = useState([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [location, setLocation] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [company, setCompany] = useState([]);
  const [product, setProduct] = useState([]);
  const [selectedPartyName, setSelectedPartyName] = useState(null);
  const [partyNameOptions, setPartyNameOptions] = useState([]);
  const [unit, setUnit] = useState("");
  const [materialData, setMaterialData] = useState({
    party_name_id: "",
    quantity: "",
    type: "",
    balance_stock: "",
    consumed_stock: "",
    status: "",
    over_stock: "",
    shortage_stock: "",
    damage_stock: "",
    date: "",
    opening_stock: "",
  });

  const selectedPartyNameId = selectedPartyName?.id || "";
  const getMaterial = async () => {
    let BASE_URL = SERVER_URL + `/api/raw-mat/raw-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data);
    setMaterial(result.data);
  };

  useEffect(() => {
    getMaterial();
  }, []);

  const handleMaterialChange = (e) => {
    const selectedMaterial = Material.find(
      (item) => item.material_name === e.target.value
    );
    console.log("selectedMaterial", selectedMaterial.id);
    setSelectedMaterialId(selectedMaterial.id);
    // setSelectedCompanyId(selectedCompany ? selectedCompany.company_id : "");
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else setCompany([]);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const selectedCompany = company.find(
      (item) =>
        item.company_name === e.target.value.split(",")[0] &&
        item.location === e.target.value.split(",")[1]
    );

    // setLocation(selectedCompany?.location || "");
    setSelectedCompanyId(selectedCompany?.id || "");
  };

  const handleUnitChange = (e) => {
    setUnit(e.target.value);
  };
  // const getProduct = async () => {
  //   const BASE_URL =
  //     SERVER_URL +
  //     `/api/raw-mat/all-products/${user_id}?date=${
  //       moment().format("YYYY-MM-DD") + "T00:00:00.000Z"
  //     }`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   // console.log(result.data)
  //   setProduct(result.data);
  // };

  // useEffect(() => {
  //   getProduct();
  // }, []);

  const handleProductChange = (e) => {
    setSelectedProductId(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMaterialData(() => {
      return {
        ...materialData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      party_name_id,
      quantity,
      type,
      balance_stock,
      consumed_stock,
      status,
      over_stock,
      shortage_stock,
      damage_stock,
      date,
      opening_stock,
    } = materialData;

    const renewalDate = moment.utc(selectedDate, "YYYY-MM-DD").toISOString();
    const BASE_URL =
      SERVER_URL + `/api/raw-mat/raw-material-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "post",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        party_name_id: selectedPartyNameId,
        quantity,
        unit: unit,
        type,
        balance_stock,
        consumed_stock,
        status,
        over_stock: over_stock ? over_stock : 0,
        shortage_stock: shortage_stock ? shortage_stock : 0,
        damage_stock: damage_stock ? damage_stock : 0,
        date: renewalDate,
        opening_stock: opening_stock ? opening_stock : 0,
        company_id: selectedCompanyId,
        product_id: selectedProductId,
        material_id: selectedMaterialId,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      toast.success(response.message);
      formRef.current.reset();
      getData();
    } else {
      toast.error(response.message);
    }
  };

  const handlePartyNameChange = (selectedOption) => {
    // console.log("selectedOption", selectedOption)
    setSelectedPartyName(selectedOption);
  };

  const handleCreate = async (inputValue) => {
    // Handle the creation of a new option here
    // console.log("Option created:", inputValue);
    let BASE_URL = SERVER_URL + `/api/raw-mat/party-name/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        party_name: inputValue,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }

    // Add the new option to the options list if needed
    const newOption = { label: inputValue, value: inputValue };
    setPartyNameOptions([...partyNameOptions, newOption]);

    // Set the selected party name to the newly created option
    setSelectedPartyName(newOption);
  };

  const getPartyName = async () => {
    let BASE_URL = SERVER_URL + `/api/raw-mat/all-party-name/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      // Update the party name options
      setPartyNameOptions(
        result.data.map((party) => ({
          label: party.party_name,
          value: party.party_name,
          id: party.id,
        }))
      );
    } else {
      setPartyNameOptions([]);
    }
  };

  useEffect(() => {
    getPartyName();
  }, []);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Raw Material Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <div className="limit_content">
                      {/* <div>
                        <h4 className="card-title">Add Raw Material Details</h4>
                      </div> */}
                      {/* <div>
                        <button
                          className="btn btn-outline-primary"
                          data-toggle="modal"
                          data-target="#limitModal"
                        >
                          Limit
                        </button>
                      </div> */}
                    </div>
                    <form className="form-sample" ref={formRef}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Product</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleProductChange}
                              value={selectedProductId}
                            >
                              <option>Select</option>
                              {product?.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.id}
                                  >{`Product - ${item.product_name}, Size - ${item.size}, Quantity - ${item.quantity}`}</option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Date">Party Name</label>
                            <Creatable
                              isClearable
                              onChange={handlePartyNameChange}
                              onCreateOption={handleCreate}
                              options={partyNameOptions}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="Date"
                              // placeholder="Document Name"

                              onChange={(e) =>
                                setSelectedDate(new Date(e.target.value))
                              }
                              value={moment(selectedDate).format("YYYY-MM-DD")}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Material Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleMaterialChange}
                            >
                              <option>Select</option>
                              {Material.map((item, id) => {
                                return (
                                  <>
                                    <option key={id}>
                                      {item.material_name}
                                    </option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Party">Party Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="party_name"
                              id="Party"
                              placeholder="Party Name"
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                            >
                              <option value="">Select</option>
                              {company.map((item, id) => {
                                return (
                                  <option
                                    key={id}
                                  >{`${item.company_name},${item.location}`}</option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Unit</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleUnitChange}
                            >
                              <option>Select</option>
                              return (
                              <>
                                <option>CFT</option>
                                <option>KG</option>
                                <option>BAGS</option>
                                <option>DRUM</option>
                                <option>LITRE</option>
                              </>
                              );
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Opning">Incoming Stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="opening_stock"
                              id="Opening"
                              placeholder="Incoming Stock"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Balance">Stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="balance_stock"
                              id="Balance"
                              placeholder="Stock"
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Consumed">Consumed Stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="consumed_stock"
                              id="Consumed"
                              placeholder="Consumed Stock"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="over">Over Stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="over_stock"
                              id="over"
                              placeholder="Over Stock"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Shortage">Shortage Stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="shortage_stock"
                              id="Shortage"
                              placeholder="Shortage Stock"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-">
                          <div className="form-group">
                            <label htmlFor="Damage">Damage Stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="damage_stock"
                              id="Damage"
                              placeholder="Damage Stock"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="limitModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="basicModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title " id="myModalLabel"></h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <form className="form-sample" ref={formRef}>
                  {/* <p className="card-description">Personal info</p> */}
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="stock">Current Stock</label>
                        <input
                          type="text"
                          className="form-control"
                          name="date"
                          id="stock"
                          placeholder="Current Stock"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="Party">Party Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="party_name"
                          id="Party"
                          placeholder="Party Name"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary mr-2 mt-3"
                    type="submit"
                    onClick={handleAddDataSubmit}
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRawMaterialModal;
